// MembershipEditWizard.js
import React, { useState, useEffect } from 'react';
import ProductService from '../../../../../../../../services/api/product.service';
import APIResponse from '../../../../../../../templates/components/APIResponse';
import MembershipWizard from '../membership-form/MembershipWizard';
import moment from 'moment';

const MembershipEditWizard = ({ id, refresh, onClose, exitHandler }) => {
  const [formData, setFormData] = useState({});
  const [isLoaded, setIsLoaded] = useState(false);
  const [apiResponse, setApiResponse] = useState(null);

  useEffect(() => {
    setIsLoaded(false);
    ProductService.getProductById({ id })
      .then(setFormData)
      .catch(console.error)
      .finally(() => setIsLoaded(true));
  }, [id]);

  const onSuccess = () => {
    refresh?.();
    onClose?.();
    exitHandler?.();
  };

  const submitHandler = (data, items) => {
    const reqObj = {
      id: data.id,
      name: data.name,
      membershipType: data.membershipType,
      membershipPeriodUnit: data.membershipPeriodUnit,
      membershipPeriodQty: isNaN(data?.membershipPeriodQty) ? 0 : Number(data.membershipPeriodQty),
      unitPrice: isNaN(data?.unitPrice) ? 0 : Number(data.unitPrice),
      membershipInstructions: data.membershipInstructions || "",
      practiceLocationId: data.practiceLocationId,
      itemType: 5,
      membershipItemsNeverExpire: data.membershipItemsNeverExpire,
      membershipOfferBeginsOn: moment(data.membershipOfferBeginsOn).startOf('day').toISOString(),
      membershipOfferEndsOn: data.membershipOfferEndsOn
        ? moment(data.membershipOfferEndsOn).startOf('day').toISOString()
        : null,
      membershipItems: items.filter(x => x.itemId !== null).map(x => {
        if (x.priceOverride && (x.unitPrice === "" || x.unitPrice == null)) x.unitPrice = 0;
        else if (!x.priceOverride) x.unitPrice = null;

        if (x.discountOverride && (x.discount === "" || x.discount == null)) x.discount = 0;
        else if (!x.discountOverride) x.discount = null;

        return x;
      })
    };

    // Include rollOver fields for Option Package (1) and Bank (3)
    if ([1, 3].includes(data.membershipType)) {
      reqObj.rollOverQtyLimit = data.rollOverQtyLimit;
      reqObj.rollOverTimeLimit = data.rollOverTimeLimit;
    }

    if (reqObj.membershipItemsNeverExpire) {
      reqObj.membershipItemsNeverExpire = 1;
    } else {
      delete reqObj.membershipItemsNeverExpire;
    }

    ProductService.editProduct(reqObj)
      .then(setApiResponse)
      .catch(setApiResponse);
  };

  return (
    <>
      {isLoaded && (
        <MembershipWizard
          isEdit={true}
          initialData={formData}
          onSubmit={submitHandler}
          onClose={onClose}
        />
      )}
      <APIResponse apiResponse={apiResponse} onSuccess={onSuccess} toastOnSuccess={true} />
    </>
  );
};

export default MembershipEditWizard;
